<template>
	<section class="section home">
		<div class="container">
			<Loading :active.sync="loading"></Loading>
			<section>
				<FeaturedCountriesFilter />
				<div class="tile is-ancestor">
					<Cmspos position="main-page"></Cmspos>
					<div class="tile is-parent is-6">
						<div class="tile is-child box tile-right">
							<div v-if="latest.Auction && latestLoading" class="overlay">
								<h2 class="title">{{ latest.Auction.name }}</h2>
								<div v-if="latest.Auction.status == 'visible'">
									<b-button type="is-danger" expanded tag="router-link" :to="{ name: 'Products' }">
										{{$t('Browse the lots from our upcoming auction!')}}
									</b-button>
								</div>
								<div v-else-if="latest.Auction.status == 'finished'">
									<b-button type="is-danger" expanded tag="router-link" :to="{ name: 'Products' }">
										{{$t('FINISHED')}}
									</b-button>
								</div>
								<div v-else-if="latest.Auction.status == 'active'">
									<h2 v-if="duration > 1 && duration < 43200" class="subtitle">
										{{ remTimeFormat(time, latest.Auction.start) }}
									</h2>
									<p v-if="duration >= 43200" class="subtitle">
										<b-button type="is-danger" expanded tag="router-link" :to="{ name: 'Products' }">
										{{ $t('Starts soon') }}
										</b-button>
									</p>
									<p v-else-if="duration > 1 && duration < 43200" class="subtitle">
										<b-button type="is-danger" expanded tag="router-link" :to="{ name: 'Products' }">
											{{$t('LIVE')}}
										</b-button>
									</p>
									<p v-else-if="duration <= 1">
										<b-button type="is-danger" expanded tag="router-link" :to="{ name: 'Products' }">
											{{$t('LIVE') }}
										</b-button>
									</p>
								</div>
							</div>
							<div v-else class="overlay">
								<h2 class="title">{{ $t('Our next auction is coming soon.') }}</h2>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section v-if="bids.length > 0">
				<hr>
				<h2 class="title">{{ $t('Featured products') }}</h2>
				<div class="has-text-centered">
					<b-button type="is-primary" tag="router-link" :to="{ name: 'Products' }" :title="$t('View all products')">
						{{ $t('All products') }}
					</b-button>
				</div>
				<div class="productgrid">
					<ProductCard
						v-for="(bid, index) in bids"
						:key="index"
						:_bid="bid"
						:_index="index"
						:_currency="currency"
						:_time="time"
						:_lang="
							bid.Product.long_description
								? JSON.parse(bid.Product.long_description)
								: { en: { name: bid.Product.name, description: bid.Product.description } }
						"
					/>
				</div>
				<div class="has-text-centered">
					<b-button type="is-primary" tag="router-link" :to="{ name: 'Products' }" :title="$t('View all products')">
						{{ $t('All products') }}
					</b-button>
				</div>
			</section>
		</div>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay'
import Cmspos from '@/components/common/Cmspos.vue'
import FeaturedCountriesFilter from '@/components/common/FeaturedCountriesFilter'
import ProductCard from '@/components/frontend/products/ProductCard.vue'

export default {
	name: 'Home',
	components: {
		Loading,
		Cmspos,
		FeaturedCountriesFilter,
		ProductCard,
	},
	metaInfo () {
		return {
			title: this.$t("Home"),
		}
	},
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			isConnected: false,
			socketMessage: '',
			currency: localStorage.getItem('currency') || 'HUF',
			msg: 'response',
			getAuction: [],
			nextProduct: null,
			latest: { Auction: null },
			time: this.$moment(),
			time_local: this.$moment(),
			time_server: this.$moment(),
			timeleft: null,
			duration: 1,
			user: Math.floor(Math.random() * 100),
			loading: true,
			backendUrl: this.$backendUrl,
			bids: [],
			isActive: true,
			locale: this.$i18n.locale,
			timerIsRun: false,
			bidSample: {
				price: null,
				finish: null,
			},
			latestLoaded: false,
		}
	},
	mounted() {
		var _this = this
		_this.loading = true
		_this.getFeaturedProducts(_this, (_this) => {
			_this.getNextProduct(_this, (_this) => {
				_this.$root.$on('change_locale', function () {
					_this.loading = false
				})
				_this.loading = false
				// get next auction
			})
		})
		//_this.calcRemainingTime(_this);
	},
	methods: {
		calcRemainingTime(_this) {
			_this.time = _this.$moment().add(_this.durationTime) //.format('YYYY-MM-DD HH:mm:ss');
			if (_this.latest && _this.latest.Auction) {
				var nextProduct = _this.$moment(_this.latest.Auction.start)
				//console.log("nextProduct", nextProduct);
				//console.log("[====================] check the remaining time in minutes [====================]")
				var timeleft = _this.$moment.duration(_this.time.diff(nextProduct)).as('minutes')
				//console.log("Visszaszámolt percek", timeleft);
				_this.timeleft = timeleft
				//console.log("[====================] check the remaining time in minutes [====================]")
				var duration = _this.$moment.duration(nextProduct.diff(_this.time)).as('minutes')
				//console.log("Hátralevő percek", duration);
				_this.duration = duration
			}
			setTimeout(function () {
				_this.calcRemainingTime(_this)
			}, 1100 - _this.time.milliseconds())
		},
		getFeaturedProducts(_this, cb) {
			_this.$http
				// nem kell már a user post body ba, nincs licit a kezdőlapon és favorites sem
				.get('products/featured')
				.then((response) => {
					console.log('FEATURED:', response)
					// eslint-disable-next-line no-undef
					_this.bids = _.shuffle(response.data.bids)
					_this.loading = false
					cb(_this)
				})
				.catch((error) => {
					console.log(error)
					cb(_this)
				})
		},
		getNextAuction(_this, cb) {
			_this.$http
				.get('auction/next')
				.then((response) => {
					_this.getAuction = response.data.auctions
					_this.nextAuction = _this.getAuction[0]
					_this.loading = false
					cb(_this)
				})
				.catch((error) => {
					console.log(error)
					cb(_this)
				})
		},
		getNextProduct(_this, cb) {
			_this.$http
				.get('products/latest')
				.then((response) => {
					_this.latest = response.data
					_this.loading = false
					_this.latestLoading = true
					cb(_this)
				})
				.catch((error) => {
					console.log(error)
					cb(_this)
				})
		},
	},
	sockets: {
		connect() {
			// Fired when the socket connects.
			this.isConnected = true
			console.log('connect')
		},

		disconnect() {
			this.isConnected = false
			console.log('disconnect')
		},

		respLicit(data) {
			console.log('data')
			this.socketMessage = data
		},
		serverTime(data) {
			var _this = this
			if (_this.timerIsRun == false) {
				const servertime = _this.$moment(data)
				_this.durationTime = _this.$moment.duration(servertime.diff(this.$moment()))
				_this.calcRemainingTime(_this)
				_this.timerIsRun = true
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section.home >>> .tile-left,
.section.home .tile-right {
	background-size: cover;
	background-repeat: no-repeat;
}
.section.home >>> .tile-left {
	background-image: url('../../assets/images/HTAukciobalkep4.jpg');
}
.section.home .tile-right {
	background-image: url('../../assets/images/HTA2020-09-13kep.jpg');
	display: flex;
	flex-direction: column;
	align-items: center;
}
* >>> .overlay {
	padding: 1rem;
	background-color: #ffffff99;
	text-align: center;
}
* >>> .overlay .title,
* >>> .overlay .subtitle {
	color: #363636;
	text-shadow: #eee7e7;
}
.inactive {
	opacity: 0.7;
	background: #eee7e7;
}

.productgrid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	grid-gap: 1rem;
	margin: 1.5rem 0;
}
</style>
